// @ts-check
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Page, Row, TabbedWidget } from 'shared/containers/portal_layout';
import { reduxForm } from 'utils/reduxFormWrapper';
import TabPane from 'shared/components/TabPane';
import MyInfo from './MyInfo';
import ChangePassword from './ChangePassword';
import NotificationPreferences from './NotificationPreferences';
import LoadingContent from 'shared/components/LoadingContent';
import ImageForm from 'shared/components/ImageForm';
import actions from './actions';
import FlashMessageActions from 'shared/actions/FlashMessageActions';

class Edit extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { currentAgent: null };
    this.updateCurrentAgent = this.updateCurrentAgent.bind(this);
    this.refresh = this.refresh.bind(this);
    this.updateAvatar = this.updateAvatar.bind(this);
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    actions.fetchCurrentAgent().then(currentAgent => this.setState({ currentAgent }));
  }

  updateCurrentAgent(formValues, dispatch) {
    return actions.updateCurrentAgent(formValues, dispatch).then(response => {
      FlashMessageActions.flashSuccess({ message: 'You have updated your account' });
    });
  }

  updateAvatar(formValues) {
    return actions.updateAvatar(formValues).then(response => {
      FlashMessageActions.flashSuccess({ message: 'Your image has been updated' });
      this.refresh();
    });
  }

  render() {
    if (!this.state.currentAgent) return <LoadingContent />;
    return (
      <PresentationComponent
        updateCurrentAgent={this.updateCurrentAgent}
        updateAvatar={this.updateAvatar}
        currentAgent={this.state.currentAgent}
        defaultTabName={this.props.route.defaultTabName}
      />
    );
  }
}

const PresentationComponent = ({
  defaultTabName,
  currentAgent,
  updateAvatar,
  updateCurrentAgent,
}) => (
  <Page title="Edit My Account">
    <Row>
      <TabbedWidget span={12} defaultTabName={defaultTabName}>
        <TabPane tabName="My Info">
          <FormifiedMyInfo
            form="updateCurrentAgent"
            onSubmit={updateCurrentAgent}
            initialValues={currentAgent}
            currentAgent={currentAgent}
          />
        </TabPane>
        {currentAgent.profileImagePath && (
          <TabPane tabName="My Photo">
            <FormifiedImageForm
              form="updateAvatar"
              onSubmit={updateAvatar}
              currentImage={currentAgent.profileImagePath}
            />
          </TabPane>
        )}
        <TabPane tabName="Change Password">
          <div data-spec-id="change-password-tab">
            <ChangePassword />
          </div>
        </TabPane>
        <TabPane tabName="Email/Notification Preferences">
          <NotificationPreferences />
        </TabPane>
      </TabbedWidget>
    </Row>
  </Page>
);

PresentationComponent.propTypes = {
  defaultTabName: PropTypes.string,
  currentAgent: PropTypes.object.isRequired,
  updateAvatar: PropTypes.func.isRequired,
  updateCurrentAgent: PropTypes.func.isRequired,
};

const FormifiedImageForm = reduxForm({})(ImageForm);
const FormifiedMyInfo = reduxForm({})(MyInfo);

export default Edit;
